import { CircularProgress, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CampaignStatus, formatNumberWithComma } from "../../config";
import { apiGatewayAxiosInstance } from "../../utils/axios";

export default function CampaignReport({ campaignData, setErrorResponse }) {

    const [counts, setCounts] = useState({
        totalSubmitted: 0,
        totalSentRCS: 0,
        totalDelivered: 0,
        totalRead: 0,
        totalFailed: 0,
        totalClicks: 0,
        totalDisableFailed: 0,

    });


    const [loading, setLoading] = useState(false);

    const getCampaignReportFromCampaignMIS = async () => {
        try {
            setLoading(true);
            // const response = await apiGatewayAxiosInstance.get(`/mis_server/campaign/get-reports-for-list-campaigns`, {
            //     headers: {
            //         "Content-Type": "application/json",
            //     },
            //     params: {
            //         campaignId: campaignData._id,
            //         executedTime: campaignData.executedTime,
            //         startTime: campaignData.startTime,
            //     },
            // });
            const response = await apiGatewayAxiosInstance.post(`mis_server/master-mis/get-count-reports`, {

                campaignId: campaignData._id,

            });
            if (response.status === 200) {
                setCounts(response.data);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";
            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            // setErrorResponse(errorMessage);

        }

        setLoading(false);

    };


    useEffect(() => {
        if (campaignData.status === CampaignStatus.Executed || campaignData.status === CampaignStatus.SMS_Executed) {
            getCampaignReportFromCampaignMIS();
        } else {
            setCounts({
                totalUploadedNumbers: campaignData.totalUploadedNumbers || 0,
                totalRcsEnabledNumbers: campaignData.totalRcsEnabledNumbers || 0,
                totalRcsDisabledNumbers: campaignData.totalRcsDisabledNumbers || 0,
                totalInValidNumbers: campaignData.totalInValidNumbers || 0,
            });
        }
    }, []);

    /* ================================================================= (UI) =================================================================== */
    return (
        <Grid
            container
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
            }}
        >

            {campaignData.status === CampaignStatus.Executed || campaignData.status === CampaignStatus.SMS_Executed ? (
                <Grid
                    item
                    md={12}
                    sx={{
                        // display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        flexWrap: "wrap !important",
                    }}
                    gap={15}
                >
                    <Grid>
                        <Typography
                            sx={{
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            TOTAL :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalSubmitted) ?? "-"
                            )}
                        </Typography>
                    </Grid>

                    <Grid>
                        <Typography
                            color="GrayText"
                            sx={{
                                display: "flex",
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <Unpublished fontSize='small' sx={{ margin: "5px" }} /> */}
                            DISABLED :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalDisableFailed) ?? "-"
                            )}
                        </Typography>
                    </Grid>

                    <Grid>
                        <Typography
                            color="primary"
                            sx={{
                                display: "flex",

                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <RcsSentIcon /> */}
                            SENT :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalSentRCS) ?? "-"
                            )}
                        </Typography>
                    </Grid>

                    <Grid>
                        <Typography
                            color="green"
                            sx={{
                                display: "flex",

                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <RcsDeliveredIcon /> */}
                            DELIVERED :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalDelivered) ?? "-"
                            )}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography
                            color="error"
                            sx={{
                                display: "flex",
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <Unpublished fontSize='small' sx={{ margin: "5px" }} /> */}
                            FAILED :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalFailed) ?? "-"
                            )}
                        </Typography>
                    </Grid>

                    <Grid>
                        <Typography
                            color="darkblue"
                            sx={{
                                display: "flex",
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <RcsReadIcon /> */}
                            READ :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalRead) ?? "-"
                            )}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography
                            color="#9003fc"
                            sx={{
                                display: "flex",
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <RcsReadIcon /> */}
                            CLICKS :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                counts?.totalClicks ?? "-"
                            )}
                        </Typography>
                    </Grid>

                </Grid>
            ) : (
                <Grid
                    item
                    md={12}
                    sx={{
                        // display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        flexWrap: "wrap !important",
                    }}
                    gap={15}
                >
                    <Grid>
                        <Typography
                            sx={{
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            TOTAL :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalUploadedNumbers) ?? "-"
                            )}
                        </Typography>
                    </Grid>

                    <Grid>
                        <Typography
                            color="primary"
                            sx={{
                                display: "flex",

                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <RcsDeliveredIcon /> */}
                            ENABLE :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalRcsEnabledNumbers) ?? "-"
                            )}
                        </Typography>
                    </Grid>

                    <Grid>
                        <Typography
                            color="GrayText"
                            sx={{
                                display: "flex",
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            {/* <Unpublished fontSize='small' sx={{ margin: "5px" }} /> */}
                            DISABLED :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalRcsDisabledNumbers) ?? "-"
                            )}
                        </Typography>
                    </Grid>

                    {/* <Grid>
                        <Typography
                            color="error"
                            sx={{
                                display: "flex",
                                fontSize: "0.7rem !important",
                                fontWeight: "bold",
                            }}
                        >
                            INVALIED :{" "}
                            {loading ? (
                                <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={12} />
                            ) : (
                                formatNumberWithComma(counts.totalInValidNumbers) ?? "-"
                            )}
                        </Typography>
                    </Grid> */}


                </Grid>
            )}
        </Grid>
    );
}
